import React from 'react';
import PropTypes from 'prop-types';

import DownloadCSVForm from './DownloadCSVForm/DownloadCSVForm'
import Modal from '../UI/Modal/Modal'

const downloadCSVModal = (props) => (
    <Modal
      show={props.show}
      modalClosed={props.modalClosed}
      >
      <DownloadCSVForm
        activeQuery={props.activeQuery}
        hostname={props.hostname}
        confirm={props.confirm}
        cancel={props.cancel}
        />
    </Modal>
)

downloadCSVModal.propTypes = {
    show: PropTypes.bool.isRequired,
    modalClosed: PropTypes.func.isRequired,
    activeQuery: PropTypes.string.isRequired,
    hostname: PropTypes.string.isRequired,
    confirm: PropTypes.func.isRequired,
    cancel: PropTypes.func.isRequired,
}

export default downloadCSVModal;



// WEBPACK FOOTER //
// ./src/Components/DownloadCSVModal/DownloadCSVModal.js